<template>
  <div class="custom-message" :class="typeClass">
    <div class="message-container">
      <div class="message-icon">
        <template v-if="messageType === 'success' && hasIcon">
          <img src="/assets/images/toast-icon-success-desktop.svg" class="desktop" alt="">
          <img src="/assets/images/toast-icon-success-mob.svg" class="mobile" alt="">
        </template>
        <template v-else-if="messageType === 'error' && hasIcon">
          <img src="/assets/images/toast-icon-error-desktop.svg" class="desktop" alt="">
          <img src="/assets/images/toast-icon-error-mob.svg" class="mobile" alt="">
        </template>
        <template v-else-if="messageType === 'warning' && hasIcon">
          <img src="/assets/images/toast-icon-warning-desktop.svg" class="desktop" alt="">
          <img src="/assets/images/toast-icon-warning-mob.svg" class="mobile" alt="">
        </template>
      </div>
      <div class="message-body">
        <h5 class="title" v-if="messageTitle">{{ messageTitle }}</h5>
        <p class="text" v-if="messageText">{{ messageText }}</p>
      </div>
      <button class="message-close" @click.prevent="flashMessage.deleteMessage(messageId)">
        <i class="icon-sc-close"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'custom-message',
  props: {
    messageId: Number
  },
  computed: {
    messageText () {
      return this.$parent.messageObj.message
    },
    messageTitle () {
      return this.$parent.messageObj.title
    },
    messageType () {
      return this.$parent.messageObj.status
    },
    typeClass () {
      return {
        [`type-${this.$parent.messageObj.status}`]: this.$parent.messageObj.status
      }
    },
    hasIcon () {
      return this.$parent.messageObj.icon !== false
    }
  }
}
</script>

<style scoped lang="scss">
.custom-message {
  background-color: $dark;
  color: $white;
  padding: 10px;
  max-width: 340px;
  min-height: 48px;

  @media (map_get($breakpoints, sm)) {
    background-color: $white;
    color: $text;
    padding: 16px;
    max-width: 416px;
  }

  &.type-error {
    background-color: $primary;

    @media (map_get($breakpoints, sm)) {
      background-color: $white;
    }
  }

  &.type-success {
    background-color: $success;

    @media (map_get($breakpoints, sm)) {
      background-color: $white;
    }
  }

  &.type-warning {
    background-color: $warning;

    @media (map_get($breakpoints, sm)) {
      background-color: $white;
    }
  }

  .message-container {
    display: flex;
    align-items: center;

    @media (map_get($breakpoints, sm)) {
      min-height: 68px;
    }

    .message-icon {
      flex: 0 0 auto;
      margin-right: 16px;

      .desktop {
        display: none;

        @media (map_get($breakpoints, sm)) {
          display: block;
        }
      }

      .mobile {
        display: block;

        @media (map_get($breakpoints, sm)) {
          display: none;
        }
      }
    }

    .message-body {
      flex: 1 1 auto;

      .title {
        font-size: 1.4rem;
        font-weight: bold;
        margin: 0;

        @media (map_get($breakpoints, sm)) {
          font-size: 1.8rem;
        }
      }

      .text {
        font-size: 1.4rem;
        font-weight: normal;
        margin: 0;

        @media (map_get($breakpoints, sm)) {
          font-size: 1.6rem;
        }
      }
    }

    .message-close {
      flex: 0 0 auto;
      font-size: 1.6rem;
      color: $white;
      margin-left: 1rem;
      margin-right: 1rem;
      padding: 0;

      @media (map_get($breakpoints, sm)) {
        color: $dark-grey;
        margin-bottom: auto;
        margin-left: 0;
        margin-right: 0;
      }
    }
  }
}
</style>
